/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "service-class.velocity"
 */

/***********************************************************************************************************
 *
 *   IF YOU WANT TO MODIFY/EXTEND THIS CLASS,
 *   THEN RENAME THIS FILE TO "regbp.service-base.ts" (add "-base" before ".ts") AND RE-RUN ang gen.
 *   IT WILL CREATE A BARE Service Class FILE THAT EXTENDS THIS ServiceBase Class AND IS THEN SAVE TO EDIT
 *
 ***********************************************************************************************************/

// tslint:disable
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { formdataEntity } from '../models/REGBP-V1.0.0/responses/formdata-entity.model';
import { Formdata } from '../models/REGBP-V1.0.0/formdata.model';
import { SiteList } from '../models/REGBP-V1.0.0/responses/site-list.model';
import { CountryList } from '../models/REGBP-V1.0.0/responses/country-list.model';
import { MaritalStatusList } from '../models/REGBP-V1.0.0/responses/marital-status-list.model';
import { CapacityObjectList } from '../models/REGBP-V1.0.0/responses/capacity-object-list.model';
import { RequestList } from '../models/REGBP-V1.0.0/responses/request-list.model';
import { AdministrationFileList } from '../models/REGBP-V1.0.0/responses/administration-file-list.model';
import { CourtLocationList } from '../models/REGBP-V1.0.0/responses/court-location-list.model';
import { DossierList } from '../models/REGBP-V1.0.0/responses/dossier-list.model';
import { DossierDetailsEntity } from '../models/REGBP-V1.0.0/responses/dossier-details-entity.model';
import { FormTypeList } from '../models/REGBP-V1.0.0/responses/form-type-list.model';
import { ProfileEntity } from '../models/REGBP-V1.0.0/responses/profile-entity.model';
import { Profile } from '../models/REGBP-V1.0.0/profile.model';
import { OrganisationList } from '../models/REGBP-V1.0.0/responses/organisation-list.model';
import { AuthorisationList } from '../models/REGBP-V1.0.0/responses/authorisation-list.model';
import { LitigationMotiveList } from '../models/REGBP-V1.0.0/responses/litigation-motive-list.model';
import { LegalFormList } from '../models/REGBP-V1.0.0/responses/legalform-list.model';
import { Login, LoginResponse } from '../models/REGBP-V1.0.0/login.model';
import { PasswordChange } from '../models/REGBP-V1.0.0/password-change.model';
import { BestAddress } from 'apps/justonweb/src/app/shared/models/best-address.model';
import { BestHouseNumber } from 'apps/justonweb/src/app/shared/models/best-housenumbers.model';
import { BestStreetName } from 'apps/justonweb/src/app/shared/models/best-street-name.model';
import { BestPostcode } from 'apps/justonweb/src/app/shared/models/best-postcode.model';
import { Comment } from 'apps/justonweb/src/app/shared/models/comment.model';
import { CommentType } from 'apps/justonweb/src/app/shared/models/comment-type';

@Injectable({ providedIn: 'root' })
export class RegbpServiceBase {
  constructor(private http: HttpClient) {}

  buildPath(relativePath: string): string {
    // to change the path of the url, you can either
    // 1) write an interceptor
    // 2) rename this file to "regbp.service-base.ts" ( => add "-base" before ".ts"),
    //    then regenerate and in the RegbpServiceBase file, overwrite this buildPath method
    return relativePath;
  }
  /**
   * Endpoint: /formdatas/{id}
   */
  public changeformdata(id: number, formdata: Formdata): Observable<formdataEntity> {
    const queryString = this.getQueryString([]);
    return ((request) => {
      return this.http.put(this.buildPath('/api/formdatas/' + id + '' + queryString), formdata, { observe: 'response' }).pipe(
        map((response) => {
          const instance = new formdataEntity().fromJSON(response.body) || {};
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, { id, formdata });
  }
  /**
   * Endpoint: /formdatas/{id}
   */
  public getformdata(id: number): Observable<formdataEntity> {
    const queryString = this.getQueryString([]);
    return ((request) => {
      return this.http.get(this.buildPath('/api/formdatas/' + id + '' + queryString), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new formdataEntity().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, { id });
  }
  /**
   * Endpoint: /sites/
   */
  public getSites(lang?: string): Observable<SiteList> {
    const queryString = this.getQueryString([{ name: 'lang', value: lang }]);
    return ((request) => {
      return this.http.get(this.buildPath('/api/sites/' + queryString), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new SiteList().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, { lang });
  }
  /**
   * Endpoint: /countries/
   */
  public getCountryList(lang?: string): Observable<CountryList> {
    const queryString = this.getQueryString([{ name: 'lang', value: lang }]);
    return ((request) => {
      return this.http.get(this.buildPath('/api/countries/' + queryString), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new CountryList().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, { lang });
  }

  public getNotifications<T>(): Observable<T[]> {
    return this.http.get<{ values: T[] }>(this.buildPath('/api/notetasks/')).pipe(map((r) => r.values));
  }

  public getEvolutionNotes<T>(dossierCode: string, evolutionKey: string): Observable<T> {
    return this.http
      .get<{ values: T[] }>(this.buildPath('/api/evolutionnote/' + dossierCode + '/' + evolutionKey))
      .pipe(map((r) => r.values[0]));
  }

  public getEvolutionNoteGrades<T>(dossierCode: string): Observable<T> {
    return this.http
      .get<{ values: T[] }>(this.buildPath('/api/sites/' + dossierCode + '/users'))
      .pipe(map((r) => (<any>r.values[0]).grades));
  }

  public deleteEvolutionNote(dossierCode: string, evolutionKey: string, conversationId: string): Observable<void> {
    return this.http.delete<void>(this.buildPath('/api/noteconversation/' + dossierCode + '/' + evolutionKey + '/' + conversationId));
  }

  public saveEvolutionNote(
    dossierCode: string,
    evolutionKey: string,
    structureId: string,
    structureItem: string,
    conversation: string
  ): Observable<any> {
    const payload = {
      dossierCode,
      evolutionKey,
      structureId,
      structureItem,
      conversation,
    };
    const body = JSON.stringify(payload);
    return this.http.post<any>(this.buildPath('/api/noteconversation/' + dossierCode + '/' + evolutionKey), body);
  }

  public updateEvolutionNote(
    dossierCode: string,
    evolutionKey: string,
    structureId: string,
    structureItem: string,
    conversation: string,
    noteConversationId: string
  ): Observable<any> {
    const payload = {
      dossierCode,
      evolutionKey,
      structureId,
      structureItem,
      conversation,
      noteConversationId,
    };
    const body = JSON.stringify(payload);
    return this.http.put<any>(this.buildPath('/api/noteconversation/' + dossierCode + '/' + evolutionKey + '/' + noteConversationId), body);
  }

  public sendEvolutionNotes(dossierCode: string, evolutionKey: string, receivers: { grade: string, userId: number }[]): Observable<any> {
    const payload = {
      dossierCode,
      evolutionKey,
      receivers,
    };
    const body = JSON.stringify(payload);
    return this.http.put<any>(this.buildPath('/api/evolutionnotereceivers/' + dossierCode + '/' + evolutionKey), body);
  }

  /**
   *
   * @param type
   * @param formId
   * @returns Array of comments for a specific type on a specific form
   * Endpoint GET /comments/
   */
  public getCommentsByType(type: string, formId: string): Observable<{ values: Comment[] }> {
    return this.http.get<{ values: Comment[] }>(this.buildPath('/api/comments/' + formId)); //Later add type if JP implements search bu type for now it is not yet implemented
  }

  /**
   *
   * @param comment
   * @returns no return
   * Endpoint POST /comments/
   */
  public addComment(comment: Comment): Observable<void> {
    const queryString = this.getQueryString([{ name: 'formId', value: comment.formId }]);
    const body = JSON.stringify(comment);
    return this.http.post<void>(this.buildPath('/api/comments/' + comment.formId), body);
  }

  /**
   * @param comment
   * @returns no return
   * Endpoint PUT /comments/
   */
  public updateComment(comment: Comment): Observable<void> {
    const body = JSON.stringify(comment);
    return this.http.put<void>(this.buildPath('/api/comments/' + comment.formId + '/' + comment.id), body);
  }

  /**
   *
   * @param id
   * @param formId
   * @returns
   * Endpoint DELETE /comments/
   */
  public deleteComment(id: string, formId: string): Observable<void> {
    return this.http.delete<void>(this.buildPath('/api/comments/' + formId + '/' + id));
  }

  /**
   * Endpoint: /zipcodes/
   */
  public getZipCodesList(lang?: string): Observable<unknown> {
    const queryString = this.getQueryString([{ name: 'lang', value: lang }]);
    return this.http.get(this.buildPath('/api/zipcodes/' + queryString));
  }
  /**
   * Endpoint: /maritalstatuses/
   */
  public getMaritalStatusList(lang?: string): Observable<MaritalStatusList> {
    const queryString = this.getQueryString([{ name: 'lang', value: lang }]);
    return ((request) => {
      return this.http.get(this.buildPath('/api/maritalstatuses/' + queryString), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new MaritalStatusList().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, { lang });
  }
  /**
   * Endpoint: /capacities/
   */
  public getCapacitiesList(lang?: string): Observable<CapacityObjectList> {
    const queryString = this.getQueryString([{ name: 'lang', value: lang }]);
    return ((request) => {
      return this.http.get(this.buildPath('/api/capacities/' + queryString), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new CapacityObjectList().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, { lang });
  }
  /**
   * Endpoint: /requests/
   */
  public getRequestList(): Observable<RequestList> {
    const queryString = this.getQueryString([]);
    return ((request) => {
      return this.http.get(this.buildPath('/api/requests/' + queryString), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new RequestList().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, {});
  }
  /**
   * Endpoint: /administrationFiles/
   */
  public getAdministrationFiles(): Observable<AdministrationFileList> {
    const queryString = this.getQueryString([]);
    return ((request) => {
      return this.http.get(this.buildPath('/api/administrationFiles/' + queryString), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new AdministrationFileList().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, {});
  }
  /**
   * Endpoint: /courtlocations/{landcode}/{zipcode}/
   */
  public getCourtLocationList(zipcode: string, landcode: string, lang?: string): Observable<CourtLocationList> {
    const queryString = this.getQueryString([{ name: 'lang', value: lang }]);
    return ((request) => {
      return this.http
        .get(this.buildPath('/api/courtlocations/' + landcode + '/' + zipcode + '/' + queryString), { observe: 'response' })
        .pipe(
          map((response) => {
            const instance = new CourtLocationList().fromJSON(response.body);
            instance['$request'] = request; // Jira DPADEPOSIT-265
            instance['$response'] = response;
            return instance;
          })
        );
    }).call(this, { zipcode, landcode, lang });
  }

  /**
   * @param countryCode
   * @param bestAddressId optional param => If countryCode === 'BE' this needs to be filled in
   * @param zipcode optional param => If countryCode !== 'BE' this needs to be filled in
   * @returns
   */
  /*
      public getCourtLocationsNGI(countryCode: string, bestAddressId?: string, zipcode?: string):Observable<CourtLocationList>{
        let relativePath = '/api/courtlocationsNGI/' + countryCode + '/';

          if(!!bestAddressId){
            relativePath = relativePath + bestAddressId + '/';
          }else{
            relativePath = relativePath + zipcode + '/';
          }
          const url = this.buildPath(relativePath);

          return(request => {
            return this.http.get(url, {observe: 'response'})
            .pipe(map(response => {
              //let instance = new CourtLocationList().fromJSON(ownData);//response.body);
              let instance = new CourtLocationList().fromJSON(response.body);
              instance['$request'] = request; // Jira DPADEPOSIT-265
              instance['$response'] = response;


              return instance;
            }))
          }).call(this);
        }
        */

  /**
   * @param countryCode
   * @param bestAddressId optional param => If countryCode === 'BE' this needs to be filled in
   * @param zipcode optional param => If countryCode !== 'BE' this needs to be filled in
   * @returns
   */
  public getCourtLocationsNGIV2(countryCode: string, bestAddressId?: string, zipcode?: string): Observable<CourtLocationList> {
    let relativePath = '/api/courtlocationsNGIV2/' + countryCode + '/';

    if (!!bestAddressId) {
      relativePath = relativePath + bestAddressId + '/';
    } else {
      relativePath = relativePath + zipcode + '/';
    }
    const url = this.buildPath(relativePath);

    return ((request) => {
      return this.http.get(url, { observe: 'response' }).pipe(
        map((response) => {
          let instance = new CourtLocationList().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;

          return instance;
        })
      );
    }).call(this);
  }

  public getLocationDistricts(lang: string): Observable<any> {
    const queryString = this.getQueryString([{ name: 'lang', value: lang }]);
    return this.http.get(this.buildPath('/api/sites' + queryString));
  }

  public getSite(dossierCode: string): Observable<any> {
    return this.http.get(this.buildPath('/api/sites/' + dossierCode));
  }

  public getBestPostcodes(lang: string, partPostcode: string): Observable<BestPostcode> {
    if (!!partPostcode) {
      const queryString = this.getQueryString([{ name: 'lang', value: lang }]);
      const relativePath = '/api/best/postalcodes/' + partPostcode + queryString;
      const url = this.buildPath(relativePath);
      return ((request) => {
        return this.http.get(url, { observe: 'response' }).pipe(
          map((response) => {
            let instance = new BestPostcode().fromJSON(response.body);
            instance['$request'] = request; // Jira DPADEPOSIT-265
            instance['$response'] = response;
            return instance;
          })
        );
      }).call(this);
    }
  }

  public getBestStreetName(lang: string, postcode: string, partStreetName: string): Observable<BestStreetName> {
    //We need te remove spaces and replace '.' with '_' before sending to the endpoint otherwise the endpoint is not able to process the request correct
    partStreetName = partStreetName.replace(/\s/g, '').replace(/\./g, '_');
    if (!!partStreetName) {
      const queryString = this.getQueryString([{ name: 'lang', value: lang }]);
      const relativePath = '/api/best/postalcodes/' + postcode + '/streets/' + partStreetName + queryString;
      const url = this.buildPath(relativePath);
      return ((request) => {
        return this.http.get(url, { observe: 'response' }).pipe(
          map((response) => {
            let instance = new BestStreetName().fromJSON(response.body);
            instance['$request'] = request; // Jira DPADEPOSIT-265
            instance['$response'] = response;
            return instance;
          })
        );
      }).call(this);
    }
  }

  public getBestHouseNumbers(postcode: string, lang: string, bestStreetNameId: string): Observable<BestHouseNumber> {
    const queryString = this.getQueryString([{ name: 'lang', value: lang }]);
    const relativePath = '/api/best/postalcodes/' + postcode + '/streets/' + bestStreetNameId + '/housenumbers' + queryString;
    const url = this.buildPath(relativePath);

    return ((request) => {
      return this.http.get(url, { observe: 'response' }).pipe(
        map((response) => {
          let instance = new BestHouseNumber().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this);
  }

  public getBestAddress(lang: string, bestAddressId: string): Observable<BestAddress> {
    const queryString = this.getQueryString([{ name: 'lang', value: lang }]);
    const relativePath = '/api/best/address/' + bestAddressId + queryString;
    const url = this.buildPath(relativePath);

    return ((request) => {
      return this.http.get(url, { observe: 'response' }).pipe(
        map((response) => {
          let instance = new BestAddress().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this);
  }

  /**
   * Endpoint: /dossier-unread/:dossierId
   */
  public getDossierUnread(dossierId: string): Observable<any> {
    return ((request) => {
      return this.http.get(this.buildPath('/api/dossier-unread/' + dossierId), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new DossierList().fromJSON(response.body);
          instance['$request'] = request;
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, {});
  }

  /**
   * Endpoint: /dossiers/
   */
  public getDossierAccessList(id: string): Observable<any> {
    return ((request) => {
      return this.http.get(this.buildPath('/api/dossierAccessList/' + id), { observe: 'response' }).pipe(
        map((response) => {
          const instance = response.body;
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, {});
  }

  /**
   * Endpoint: /dossiers/
   */
  public getSiteDossierList(
    siteId: string,
    lang: string,
    type: 'R' | 'P' | 'X' | 'A' = 'R',
    status: 'O' | 'C' | 'A' = 'A'
  ): Observable<DossierList> {
    const queryString = this.getQueryString([
      { name: 'lang', value: lang },
      { name: 'caseType', value: type },
      { name: 'caseState', value: status },
    ]);
    return ((request) => {
      return this.http.get(this.buildPath('/api/siteDossiers/' + siteId + queryString), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new DossierList().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, {});
  }

  /**
   * Endpoint: /dossiers/
   */
  public getDossierList(lang: string, type: 'R' | 'P' | 'X' | 'A' = 'R', status: 'O' | 'C' | 'A' = 'A'): Observable<DossierList> {
    const queryString = this.getQueryString([
      { name: 'lang', value: lang },
      { name: 'caseType', value: type },
      { name: 'caseState', value: status },
    ]);
    return ((request) => {
      return this.http.get(this.buildPath('/api/dossiers/' + queryString), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new DossierList().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, {});
  }
  /**
   * Endpoint: /dossier-detail/{dossierCode}
   */
  public getDossierDetails(dossierCode: string, lang: string, auth_mime?: string, nrn_mime?: string): Observable<DossierDetailsEntity> {
    let headers = new HttpHeaders();
    if (auth_mime && nrn_mime) {
      headers = headers.append('auth_mime', auth_mime).append('nrn_mime', nrn_mime);
    }

    const queryString = this.getQueryString([{ name: 'lang', value: lang }]);

    return ((request) => {
      return this.http.get(this.buildPath('/api/dossier-detail/' + dossierCode + '' + queryString), { observe: 'response', headers }).pipe(
        map((response) => {
          const instance = new DossierDetailsEntity().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, { dossierCode, lang });
  }
  /**
   * Endpoint: /formtypes/
   */
  public getFormTypeList(infile?: boolean, lang?: string): Observable<FormTypeList> {
    const queryString = this.getQueryString([
      { name: 'infile', value: infile },
      { name: 'lang', value: lang },
    ]);
    return ((request) => {
      return this.http.get(this.buildPath('/api/formtypes/' + queryString), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new FormTypeList().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, { infile, lang });
  }
  /**
   * Endpoint: /profile/
   */
  public getProfile(): Observable<ProfileEntity> {
    const queryString = this.getQueryString([]);
    return ((request) => {
      return this.http.get(this.buildPath('/api/profile/' + queryString), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new ProfileEntity().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, {});
  }
  /**
   * Endpoint: /login
   */
  public login(login: Login): Observable<LoginResponse> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    const body = JSON.stringify(login);
    return this.http.post<LoginResponse>(this.buildPath('/api/login'), body, { headers });
  }
  /**
   * Endpoint: /passwordchange
   */
  public changePassword(passwordChange: PasswordChange): Observable<void> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    const body = JSON.stringify(passwordChange);
    return this.http.post<void>(this.buildPath('/api/passwordchange'), body, { headers });
  }
  /**
   * Endpoint: /logindata/
   */
  public getLoginData(lang: string, UUID?: string, authType?: 'citizen' | 'lawyer' | 'organisation'): Observable<ProfileEntity> {
    const queryString = this.getQueryString([
      { name: 'lang', value: lang },
      { name: 'UUID', value: UUID },
      { name: 'auth_type', value: authType },
    ]);
    console.log('performing httpGet from regbpService for loginData');
    return ((request) => {
      return this.http.get(this.buildPath('/api/logindata/' + queryString), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new ProfileEntity().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          console.log('returning profile instance from getLoginData in regbpService');
          return instance;
        })
      );
    }).call(this, {});
  }
  /**
   * Endpoint: /logindata/
   */
  public formAccess(id: string, date: string): Observable<void> {
    const queryString = this.getQueryString([]);
    const body = {
      formAccessDate: date,
    };
    return ((request) => {
      return this.http.put(this.buildPath('/api/formaccess/' + id + queryString), body, { observe: 'response' }).pipe(
        map((response) => {
          const instance = response.body || {};
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, { body });
  }
  /**
   * Endpoint: /logindata/
   */
  public updateProfile(profile: Profile): Observable<ProfileEntity> {
    const queryString = this.getQueryString([]);
    return ((request) => {
      return this.http.put(this.buildPath('/api/logindata/' + queryString), profile, { observe: 'response' }).pipe(
        map((response) => {
          const instance = new ProfileEntity().fromJSON(response.body) || {};
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, { profile });
  }
  /**
   * Endpoint: /organisations/
   */
  public getOrganisation(kbo: string): Observable<OrganisationList> {
    const queryString = this.getQueryString([{ name: 'kbo', value: kbo }]);
    return ((request) => {
      return this.http.get(this.buildPath('/api/organisations/' + queryString), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new OrganisationList().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, { kbo });
  }
  /**
   * Endpoint: /authorisations/
   */
  public getAuthorisationList(lang?: string): Observable<AuthorisationList> {
    const queryString = this.getQueryString([{ name: 'lang', value: lang }]);
    return ((request) => {
      return this.http.get(this.buildPath('/api/authorisations/' + queryString), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new AuthorisationList().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, { lang });
  }
  /**
   * Endpoint: /litigation_motives/
   */
  public getLitigationMotiveList(lang?: string): Observable<LitigationMotiveList> {
    const queryString = this.getQueryString([{ name: 'lang', value: lang }]);
    return ((request) => {
      return this.http.get(this.buildPath('/api/litigation_motives/' + queryString), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new LitigationMotiveList().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, { lang });
  }

  private getQueryString(params: { name: string; value: any }[]): string {
    let queryString = '';
    let sep = '?';
    if (params) {
      params.forEach((param) => {
        if (param.value != null) {
          queryString += sep + param.name + '=' + param.value;
          sep = '&';
        }
      });
    }
    return queryString;
  }

  /**
   * Endpoint: /legalforms/
   */
  public getLegalFormList(lang?: string): Observable<LegalFormList> {
    const queryString = this.getQueryString([{ name: 'lang', value: lang }]);
    return ((request) => {
      return this.http.get(this.buildPath('/api/legalform/' + queryString), { observe: 'response' }).pipe(
        map((response) => {
          const instance = new LegalFormList().fromJSON(response.body);
          instance['$request'] = request; // Jira DPADEPOSIT-265
          instance['$response'] = response;
          return instance;
        })
      );
    }).call(this, { lang });
  }
}

/** end of template "service-class.velocity" */
